import React from 'react';
import ConfirmModal from '../../common/ConfirmModal/ConfirmModal';
import styles from './DeleteStudentConfirmModal.module.css';

interface DeleteStudentConfirmModalProps {
  open: boolean;
  studentName: string;
  loading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteStudentConfirmModal: React.FC<DeleteStudentConfirmModalProps> = ({
  open,
  studentName,
  loading = false,
  onConfirm,
  onCancel,
}) => (
  <ConfirmModal
    open={open}
    title="Excluir aluna permanentemente"
    confirmLabel="Excluir"
    confirmDelaySeconds={10}
    cancelLabel="Cancelar"
    variant="danger"
    icon="delete_forever"
    loading={loading}
    onConfirm={onConfirm}
    onCancel={onCancel}
  >
    <p className={styles['delete-warning-lead']}>
      Você está prestes a excluir <strong>{studentName || 'esta aluna'}</strong>.
      Essa ação é irreversível e apaga todos os dados dela no portal, incluindo:
    </p>
    <ul className={styles['delete-warning-list']}>
      <li>Cadastro, endereço, telefone, anamnese e PAR-Q</li>
      <li>Fotos, histórico de treinos e FUP</li>
      <li>Contas de pagamento, assinaturas ativas no gateway, cobranças e pagamentos</li>
      <li>Vínculos com professora e demais referências</li>
    </ul>
    <p className={styles['delete-warning-footnote']}>
      Nada será mantido. Confirme apenas se tiver certeza.
    </p>
  </ConfirmModal>
);

export default DeleteStudentConfirmModal;
